import { CellGroup } from '../FlightListRow';
import { StyledRow } from '../FlightListHeader';
import * as Airline from '../columns/Airline';
import * as Airport from '../columns/Airport';
import * as DetailsLink from '../columns/DetailsLink';
import * as Time from '../columns/Time';
import * as FlightNumber from '../columns/FlightNumber';
import * as Gate from '../columns/Gate';
import * as Status from '../columns/Status';
import { TextPlaceholder } from './TextPlaceholder';
import { Shimmer } from '../../../../../../ui';

const ShimmerRow = Shimmer.withComponent(StyledRow);

export function FlightListHeaderShimmer() {
	return (
		<ShimmerRow>
			<Airline.StyledHeader>
				<TextPlaceholder />
			</Airline.StyledHeader>
			<Time.StyledHeader>
				<TextPlaceholder />
			</Time.StyledHeader>
			<CellGroup>
				<Airport.StyledHeader>
					<TextPlaceholder />
				</Airport.StyledHeader>

				<FlightNumber.StyledHeader>
					<TextPlaceholder />
				</FlightNumber.StyledHeader>
			</CellGroup>
			<Gate.StyledHeader>
				<TextPlaceholder />
			</Gate.StyledHeader>
			<Airline.StyledHeader>
				<TextPlaceholder />
			</Airline.StyledHeader>
			<CellGroup>
				<Status.StyledHeader>
					<TextPlaceholder />
				</Status.StyledHeader>
				<DetailsLink.StyledHeader> </DetailsLink.StyledHeader>
			</CellGroup>
		</ShimmerRow>
	);
}
